import { getElementsCount } from '@v2/Pages/Market/MarketConstants';
import React from 'react';

export const generatePlaceholdersByCount = (element: React.ReactNode, count: number,): React.ReactNode => getElementsCount(count)
    .map((_v, k) => <React.Fragment key={k}>{element}</React.Fragment>);
